import React, { useState, useCallback, useRef, useEffect } from "react";
import Button from "components/Button";
import Divider from "../pages/matiere/components/Divider";
import confetti from "canvas-confetti";
import Analytics from "utils/analytics";

const duration = 15 * 1000;
const animationEnd = Date.now() + duration;
const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}

function Finish({
  score,
  note,
  onQuit,
  seuil,
  onCountinue,
  data = {},
  loading = false,
  finish,
  globalNote,
}) {
  const [confettiLaunched, setConfettiLaunched] = useState(false);
  const canvasRef = useRef(null);
  const totalPossible = globalNote || 0;
  const currentNote = note || 0;
  const percent = totalPossible > 0 ? currentNote / totalPossible : 0;
  const level = String(data?.niveau || "").trim();
  const requiredPercent = level === "2" ? 1 : 0.8; // L1:80%, L2:100%, L3:80%
  const isSuccess = percent >= requiredPercent;
  // console.log("note", note)
  // console.log("requiredPercent", requiredPercent);
  // console.log("percent", percent)

  const handleContinueClick = () => {
    // Track analytics
    Analytics.trackTerminerButton("Exercise Finish", "Exercise Completion");

    // Case 1: Not successful & not finished → go directly to analysis
    if (!isSuccess) {
      onCountinue(true); // force analysis
      return;
    }

    // Case 2: Successful & not last level → go to next level
    if (isSuccess && !finish) {
      onCountinue();
      return;
    }

    // Case 3: Successful
    onCountinue();
  };


  // console.log({ note })
  // console.log(data)
  // Confetti animation
  const launchConfetti = useCallback(() => {
    if (!canvasRef.current || confettiLaunched) return;

    try {
      // useWorker: false pour éviter le crash sur Google Go / vieux WebView Android
      // qui ne supportent pas OffscreenCanvas (getBoundingClientRect n'existe pas dessus)
      const myConfetti = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: false,
      });

      const duration = 5 * 1000;
      const end = Date.now() + duration;

      const confettiAnimation = () => {
        try {
          myConfetti({
            particleCount: 3,
            startVelocity: 0,
            ticks: 300,
            origin: {
              x: Math.random(),
              y: Math.random() - 0.2,
            },
            colors: ["#0ABDC6", "#091833", "#133E7C", "#091833", "#0ABDC6"],
            shapes: ["circle", "square"],
            gravity: randomInRange(0.4, 0.6),
            scalar: randomInRange(0.4, 1),
            drift: randomInRange(-0.4, 0.4),
          });
        } catch {
          // Si le confetti échoue (navigateur incompatible), on arrête l'animation silencieusement
          return;
        }

        if (Date.now() < end) {
          requestAnimationFrame(confettiAnimation);
        }
      };

      confettiAnimation();
      setConfettiLaunched(true);
    } catch {
      // Le confetti n'est pas supporté sur ce navigateur — on ignore silencieusement
      setConfettiLaunched(true);
    }
  }, [confettiLaunched]);

  useEffect(() => {
    if (isSuccess && currentNote > 0) {
      setTimeout(() => {
        launchConfetti();
      }, 10);
    }
  }, [isSuccess, currentNote, launchConfetti]);

  // 🎯 Dynamic button label
  let buttonLabel = "Terminer";
  if (isSuccess && !finish) buttonLabel = "Continuer";

  return (
    <div className="flex flex-col items-center justify-center h-full text-center relative">
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 2,
        }}
      />
      <h1
        className="text-4xl font-bold mb-10"
        style={{ color: isSuccess ? "#37d67a" : "#e11d48" }}
      >
        {isSuccess ? "Bravo!" : "Réessayer"}
      </h1>
      <div className="text-lg mb-2">
        Votre score au test est de{" "}
        <span
          className="font-bold text-2xl"
          style={{ color: isSuccess ? "#37d67a" : "#e11d48" }}
        >
          {currentNote}/{globalNote}
        </span>
      </div>
      <div className="mt-8 flex gap-2">
        {!finish && (
          <Button
            onClick={onQuit}
            style={{ backgroundColor: "#dadada", flex: 1, height: 40 }}
            radius={"md"}
          >
            Quitter
          </Button>
        )}
        <Button
          style={{ backgroundColor: "#003880", flex: 1, height: 40 }}
          radius={"md"}
          onClick={handleContinueClick}
          loading={loading}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
}

export default Finish;
